import { API_URL } from "../service.config";
import info from "../../utils/info";

export default {
  getAudit(pagination: any) {
    return API_URL.get(
      `/audit?start=${pagination.start}&quantity=${pagination.quantity}`,
      {
        headers: {
          Authorization: `Bearer ${info.getToken()}`
        }
      }
    );
  }
};
